import { createContext } from 'utils/react-helpers';

const [PolicyRegisterProvider, usePolicyRegister] = createContext({
  name: 'PolicyRegisterContext',
});

export { PolicyRegisterProvider, usePolicyRegister };
